<template>
  <div>
    <div @click="play">11231</div>
    <audio ref="audio" loop=""
           src="http://cdn.cbcnt.com/etop/audio/1421320210409/7a11912aeef84c59b4a16fcd34860d32.mp3"></audio>
  </div>
</template>

<script>
export default {
  name: 'AudioInfoPage',
  methods: {
    play () {
      console.log('点击了播放')
      this.$refs.audio.play()
    }
  },
  mounted () {
    var audio = this.$refs.audio
    $('html').one('touchstart', function () {
      audio.play()
    })
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/jyq/AudioInfoPage.vue